import React from "react";
import { formatTableCellValue } from "../utils";
const OverviewCard = ({ title, value, icon, colorClass }) => (
  <div className={`rounded-2xl p-5 shadow-sm ${colorClass}`}>
    <div className="flex items-start justify-between">
      <div className="flex flex-col">
        <p className="text-sm font-bold uppercase tracking-wide opacity-80">
          {title}
        </p>
        <p className="text-3xl font-bold mt-1">
          {formatTableCellValue(value)}
          <span className="text-lg font-medium opacity-80 ml-1">Cr</span>
        </p>
      </div>
      <div className="text-3xl opacity-70">{icon}</div>
    </div>
  </div>
);

export default OverviewCard;
